import type { AnalyticsEvent, AnalyticsSink } from "./types.js";

/** Reference sink for local dev/tests. Writes to console, nothing else. */
export class ConsoleAnalyticsSink implements AnalyticsSink {
  track(event: AnalyticsEvent): void {
    // eslint-disable-next-line no-console
    console.log("[analytics]", JSON.stringify(event));
  }
}

/** No-op sink for environments (e.g. tests) that must not log. */
export class NullAnalyticsSink implements AnalyticsSink {
  track(_event: AnalyticsEvent): void {
    // intentionally empty
  }
}
